<template>
  <div class="detail-weapon-table">
    <table>
      <tbody>
        <template v-for="(row, index) in tableList">
          <tr v-if="index <= 7" :key="index">
            <template v-for="(col, cidx) in row">
              <template v-if="calcRowspan(index, cidx) > 1">
                <td :key="cidx" :rowspan="calcRowspan(index, cidx)">
                  <template v-if="col.type === 'text'">
                    <span>
                      {{ col.value }}
                    </span>
                  </template>
                  <template v-if="col.type === 'image'">
                    <img :src="col.value" style="max-width: 100px; max-height: 100px;" />
                  </template>
                </td>
              </template>
              <template v-else>
                <td v-if="!hideCell(index, cidx)" :key="cidx">
                  <template v-if="col.type === 'text'">
                    <span>
                      {{ col.value }}
                    </span>
                  </template>
                  <template v-if="col.type === 'image'">
                    <img :src="col.value" style="max-width: 100px; max-height: 100px;" />
                  </template>
                </td>
              </template>
            </template>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>
<script>
import { apiEntryBind, apiGetEntryBindList, apiEntryTemplateDetail } from "@/api/richTable";

export default {
  name: "DetailWeaponTable",
  props: { contentData: { type: Object, default: () => ({}) } },
  computed: {
    tableList() {
      return JSON.parse(this.contentData.content_json).baseData;
    }
  },
  mounted() {
    setTimeout(() => {
      console.log(JSON.parse(JSON.stringify(this.contentData)));
      console.log(JSON.parse(this.contentData.content_json));
    }, 2000);
    // this.fetchTemplate();
  },
  methods: {
    async fetchTemplate() {
      const { code, data } = await apiEntryTemplateDetail({ type: 4 });
      if (code === 0) {
      }
    },
    calcRowspan(ridx, cidx) {
      if (cidx > 0) return 1;

      if (ridx === 0) return 2;
      if (ridx === 2 || ridx === 5) return 3;
      return 1;
    },
    hideCell(ridx, cidx) {
      if (cidx > 2) return true;
      const key = `${ridx}${cidx}`;
      let bool = false;
      switch (key) {
        case "10":
        case "20":
        case "20":
        case "30":
        case "40":
        case "60":
        case "70":
          bool = true;
          break;
        default:
          break;
      }
      return bool;
    }
  }
};
</script>
<style lang="less" scoped>
.detail-weapon-table {
  table {
    width: 100%;
    border-collapse: collapse;
  }
  tr {
    position: relative;
  }
  td {
    padding: 4px 8px;
    border: 1px solid #000;
  }
}
</style>
